import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";

const theme = {
  colors: {
    green: "#626E60",
    darkGray: "#3C3C3C",
    softGray: "#4D4D4D",
    red: "#d2767b", // 945D60
    white: "#FFFFFF",
    yellow: "#D6A82B",
    black: "#000000",
    shadow: "rgba(0,0,0,.4)",

    dark: {
      green: "#4e584c",
      darkGray: "#303030",
      red: "#764a4c",
      white: "#cccccc",
      yellow: "#ac8621",
      shadow: "rgba(0,0,0,.9)",
    },
  },

  container: "1280px",

  mediaQueries: {
    desktop: "(min-width: 840px)",
    mobile: "(max-width: 400px)",
    dashboardDesktop: "(min-width: 1000px)",
    containerMaxBreakpoint: "(min-width: 1280px)",
  },
};

let materialTheme = createMuiTheme({
  typography: {
    fontFamily: "Lato",
    htmlFontSize: 10,
    body1: {
      fontSize: 18,
    },
  },
  palette: {
    type: "dark",
    primary: {
      main: theme.colors.white,
    },
    secondary: {
      main: theme.colors.darkGray,
    },
    error: {
      main: theme.colors.red,
    },
    text: {
      primary: theme.colors.white,
      secondary: theme.colors.yellow,
    },
    background: {
      paper: theme.colors.darkGray,
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: "16px",
        color: theme.colors.white,
      },
    },
    // MuiTextField: {
    //   root: {
    //     color: theme.colors.black,
    //   },
    // },
    MuiDrawer: {
      paper: {
        width: "40%",
      },
    },
    MuiAlert: {
      standardSuccess: {
        backgroundColor: theme.colors.yellow,
      },
      standardError: {
        backgroundColor: theme.colors.red,
      },
      icon: {
        color: `${theme.colors.white} !important`,
        fontSize: "25px",
      },
      action: {
        color: theme.colors.white,
      },
    },
  },
});

// Handles font size reduction on smaller and larger screens
materialTheme = responsiveFontSizes(materialTheme);

export { theme, materialTheme };
